export enum ProductGroup {
	General = "Algemeen",
	Accessories = "Accessoires",
	Fee = "Toeslag",

	Furniture = "Meubels",
	Cabinets = "Vakkenkasten",
	Cabinets3d = "Vakkenkasten 3D",
	TosizeFurniture = "TOSIZE Furniture",
	Tables = "Tables",

	Plastic_Sheet = "Kunststof",

	Wood_Beams = "Latten en Balken",
	Wood_Panels = "Meubel- en Timmerpanelen",
	Wood_Planks = "Planken",
	Wood_Sheet = "Plaatmateriaal",
	Wood_Skirting = "Plinten",
	Wood_Samples = "Samples",
}

export enum ProductionUnit {
	M1 = "m1",
	M2 = "m2",
	CompletePanel = "completePanel",
	CompleteBeam = "completeBeam",
}

export enum ProductType {
	M2 = "Wood",
	CompletePanel = "WoodComplete",
}
